export enum CookieKey {
  // App Wide
  AUTH_TOKEN = 'auth_token', // any changes here; should also be done in index.ejs
  AUTH_TOKEN_NA = 'auth_token_na', // any changes here; should also be done in index.ejs
  AUTH_TOKEN_EU = 'auth_token_eu', // any changes here; should also be done in index.ejs
  AUTH_TOKEN_CA = 'auth_token_ca', // any changes here; should also be done in index.ejs
  I18N_LANG = 'i18n_lang',
  HARD_APP_VERSION = 'kt-webapp-version',
  KT_MOBILE_APP = 'kt_mobile_app',
  SUPPORT_USER = 'hijacker', // any changes here; should also be done in index.ejs
  SUPPORT_SESSION = 'hijacker_session',
  DASHBOARD_STORAGE = 'dashboard_storage',
  SIDE_BAR_STATUS = 'sidebar_status',
  SIDE_BAR_MAXIMIZED_STATUS = 'is_side_bar_maximized',
  DEMO_USER = 'demo_user', // any changes here; should also be done in index.ejs
  DEMO_SESSION = 'demo_session',
  REMOTE_LOGIN_TOKEN = 'remote_login_token', // any changes here; should also be done in index.ejs
  READ_ONLY_MODE = 'readonly',
  USER_ID = 'user_id',
  SENDBIRD_AUTH_TOKEN = 'sb_auth_token', // auth token to trigger sendbird connection
  CIAM_AUTH_TOKEN = 'ciam_auth_token',
  CIAM_AUTH_TOKEN_NA = "ciam_auth_token_na",
  CIAM_AUTH_TOKEN_EU = "ciam_auth_token_eu",
  CIAM_AUTH_TOKEN_CA = "ciam_auth_token_ca",
  FLEET_APP_CIAM_AUTH_TOKEN = 'fleet_app_ciam_auth_token',
  INSTALLER_ACCESS_TOKEN = 'installer_access_token',

  // Support
  APEX_USER_NAME = 'apex__user_name',
  APEX_USER_EMAIL = 'apex__user_email',
  APEX_USER_PHONE = 'apex__user_phone',

  // Growth
  USER_INFORMATION = 'user_information',
  UNIVERSAL_PIXEL = 'universal_pixel',
  UTM_PARAMS = 'utm_params',
  PLG_TRACKING_PARAMS = 'plg_tracking_params',
  UPSELL_UPGRADE_BTN_SHOW = 'upsell_upgrade_btn_show',
  UPSELL_ENTRY_POPUP_HIDE = 'upsell_entry_popup_hide',
  UPGRADE_TOPBAR_STATUS = 'upgrade_topbar_status',
  EOQ_UPSELL_TOPBAR_STATUS = 'eoq_upsell_topbar_status',
  FV_VEHICLE_DETAIL_DASHCAM_UPSELL = 'fleetview_vehicle_live_details_upsell',
  UPSELL_ENTRY_POPUP_RUN = 'upsell_entry_popup_run',

  SAFETY_EVENT_DETAIL_DASHCAM_UPSELL = 'safety_event_dashcam_upsell_banner',
  AG_UPSELL_BANNER = 'ag_upsell_banner',

  // CPA
  CPA_STATUS = 'cpa_status',
  IS_CPA_STATUS_TRACKED = 'is_cpa_status_tracked',

  // OTHERS
  SAFETY_VIEWED_COLLISION_EVENTS = 'collision_event_viewed',
  TABLEAU_TIME_OUT_COOKIE = 'tableau_time_to_live',
  
  // NON-PUBLIC CARD APP VERIFICATION TOAST
  SHOW_NON_PUBLIC_CARD_APP_VERIFY_TOAST = 'show_non_public_card_app_verify_toast',

  // Localization
  USER_LOCALE_PREFERENCE = 'user_locale_preference',
  USER_TIMEZONE_PREFERENCE = 'user_timezone_preference',
  USER_TIME_FORMAT_PREFERENCE = 'user_time_format_preference',
}
